module.exports = __webpack_public_path__ + "26953acb881626ca10b5474a3c1774d6.svg";